export default {
  billingCentreResults: [],
};
